export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8125.583e1025.jpg";